import { createContext } from 'react';

interface License {
    type: string;
    key: string;
    expires_at: string;
}

export default createContext<{ license: License | null }>({ license: null });
